import { roundOffToPlaces } from 'constants/helper';

import { LabelOption } from '../../types/competencySettingsSlice';

export interface ValidationError {
  reason: 'score' | 'label';
  index: number;
  message: string;
}

export const isScorePercentValidator = (labelSettings: LabelOption[]): ValidationError => {
  if (!labelSettings) {
    return {
      reason: 'score',
      message: 'No label settings found',
      index: -1,
    };
  }
  for (let i = 0; i < labelSettings.length; i += 1) {
    const setting = labelSettings[i];
    // previous element should not be greater than current
    if (i > 0 && roundOffToPlaces(Number(labelSettings[i - 1].upperLimit) + 0.1, 2) >= setting.upperLimit) {
      return {
        reason: 'score',
        message: 'Score should be greater than the previous score',
        index: i,
      };
    }
    if (!setting.label) {
      return {
        reason: 'label',
        message: 'Label should not be empty',
        index: i,
      };
    }
  }
  return null;
};
